window.Components.Header = function () {
  function Header() {
    this.init();
  }

  Header.prototype = $.extend({}, Header.prototype, {
    init: function () {
      this._handleScroll();
      this._handleOverlay();
    },
    _handleOverlay: function () {
      const overlay = $(".header__overlay");
      $(".header__link").hover(
        () => overlay.addClass("visible"),
        () => overlay.removeClass("visible")
      );
    },
    _handleScroll: function () {
      const headerWrapper = $(".header__outer-wrapper");
      const isHideOnScroll =
        headerWrapper.find(".header--show_on_scrollup").length > 0;

      const HEADER_HEIGHT = 114;

      if (!isHideOnScroll) return;

      let scrollPos = 0;
      $(window).scroll(function () {
        let currScrollPos = $(this).scrollTop();
        if (currScrollPos > scrollPos && currScrollPos > HEADER_HEIGHT) {
          $(".header__outer-wrapper").addClass("hide");
        } else {
          $(".header__outer-wrapper").removeClass("hide");
        }
        scrollPos = currScrollPos;
      });
    },
  });

  window.Components.Header = new Header();
};

$(function () {
  window.Components.Header();
});
